import { getWechat } from '../server/wechat.js'

const wx = window.wx

export async function initShare (shareConfig) {
  try {
    if (window.nfplusJsbridge) {
      window.nfplusJsbridge.setShareInfo({
        shareDesc: shareConfig.shareDesc,
        shareIcon: shareConfig.shareIcon,
        shareTitle: shareConfig.shareTitle,
        shareUrl: shareConfig.shareUrl
      })
    }
  } catch (e) {
    window.console.log('nfplusJsbridge setShareInfo', e)
  }

  const wxShareApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
  const shareInfo = await getWechat()

  const wxShareConfig = () => ({
    title: shareConfig.shareTitle,
    desc: shareConfig.shareDesc,
    link: shareConfig.shareUrl,
    imgUrl: shareConfig.shareIcon,
    success: async () => {}
  })
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: shareInfo.app_id, // 必填，公众号的唯一标识
    timestamp: shareInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: shareInfo.nonceStr, // 必填，生成签名的随机串
    signature: shareInfo.signature, // 必填，签名，见附录1
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-weapp']
  })
  window.wx.ready(() => {
    for (const [index, item] of wxShareApiList.entries()) {
      wx[item](wxShareConfig(index))
    }
  })
}
